import { IcoClose, IcoDownload, IcoFolder } from "./icons";

export function SignedOutSheet({
  title,
  onDownload,
  onFacture,
  onCoffre,
  onClose,
}: {
  title: string;
  onDownload: () => void;
  onFacture: () => void;
  onCoffre: () => void;
  onClose: () => void;
}) {
  return (
    <div className="sg-send-back" role="dialog" aria-label="Sortir le dossier signé">
      <div className="sg-send">
        <h2>Dossier signé</h2>
        <p className="sg-legal">{title}</p>
        <div className="sg-move-list">
          <button type="button" className="sg-btn ghost" onClick={onDownload}>
            <IcoDownload />
            Télécharger
          </button>
          <button type="button" className="sg-btn ghost" onClick={onFacture}>
            <IcoFolder />
            Classer dans Factures
          </button>
          <button type="button" className="sg-btn ghost" onClick={onCoffre}>
            <IcoFolder />
            Classer dans le Coffre
          </button>
        </div>
        <div className="sg-send__actions">
          <button type="button" className="sg-btn ghost" onClick={onClose}>
            <IcoClose />
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
}
